(function ($, Drupal) {
  Drupal.behaviors.userBehavior = {
    attach(context, settings) {
      $('.user__sidebar', context).once('userBehavior').each(function () {
        const $this = $(this);

        function initUserSideBar() {
          let $trigger = $this.find('.user-block'),
              $target = $this.find('.item-list');

          $trigger.on('click', () => {
            $trigger.toggleClass('is-open');
            $target.slideToggle(200);
          });
        }

        setTimeout(() => {
          // BigPipe done...
          if ($(window).width() < 1024) {
            initUserSideBar();
          }
        }, 100);
      });
    },
  };
}(jQuery, Drupal));
